import { http } from "./api";

export const paymentsApi = {
  createRideOrder: (ride_id) => http.post("/payments/razorpay/create-order", { ride_id }).then((r) => r.data),
  recheckRide: (ride_id) => http.post("/payments/razorpay/recheck", { ride_id }).then((r) => r.data),
  verifyRide: (body) => http.post("/payments/razorpay/verify", body).then((r) => r.data),
  createTopup: (ride_id) => http.post(`/rides/${ride_id}/topup/create`).then((r) => r.data),
  verifyTopup: (ride_id, body) => http.post(`/rides/${ride_id}/topup/verify`, body).then((r) => r.data),
  createTip: (body) => http.post("/tips/create", body).then((r) => r.data),
  verifyTip: (body) => http.post("/tips/verify", body).then((r) => r.data),
};

let loader = null;
export function loadCheckout() {
  if (window.Razorpay) return Promise.resolve(true);
  if (!loader) {
    loader = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => resolve(true);
      s.onerror = () => { loader = null; resolve(false); };
      document.body.appendChild(s);
    });
  }
  return loader;
}

// Public Razorpay Key ID (safe to expose). When set, the web opens the real checkout even if the backend order endpoint is still mock.
export const PUBLIC_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || "";
export const LIVE_MODE = /^rzp_live_/.test(PUBLIC_KEY_ID);
const backendIsMock = (o) => !!o?.mock || !o?.key_id || /MOCK/i.test(o?.key_id || "");
export const isMockOrder = (o) => backendIsMock(o) && !PUBLIC_KEY_ID;

// Opens the real Razorpay popup. Resolves with the payment response or rejects on failure/dismiss.
export async function openCheckout({ order, amount, user, description }) {
  const ok = await loadCheckout();
  if (!ok) throw new Error("Could not load Razorpay. Check your connection and try again.");
  return new Promise((resolve, reject) => {
    const useBackendOrder = !backendIsMock(order);
    const rz = new window.Razorpay({
      key: useBackendOrder ? order.key_id : PUBLIC_KEY_ID,
      amount: order.amount ?? Math.round(amount * 100),
      currency: order.currency || "INR",
      ...(useBackendOrder ? { order_id: order.order_id || order.id } : {}),
      notes: { kind: order.ride_id ? "ride" : "order", ref_id: order.ride_id || order.ref_id || "" },
      name: "KohimaTaxi & Delivery",
      description,
      image: `${window.location.origin}/icons/icon-192.png`,
      prefill: { name: user?.name || "", email: user?.email || "", contact: (user?.phone || "").replace(/\s+/g, "") },
      theme: { color: "#1D4ED8" },
      modal: { ondismiss: () => reject(Object.assign(new Error("Payment cancelled"), { cancelled: true })) },
      handler: (res) => resolve(res),
    });
    rz.on("payment.failed", (res) => reject(new Error(res?.error?.description || "Payment failed")));
    rz.open();
  });
}
